import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_148: FaireProductEntity = {
  token: "legacy_prod_abbott-148",
  type: "product",
  name: "Candy Jar with Lid-8 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/00d448110fecfd5e4872691fd96a88ba1053577f17b122f787d64ff319103176.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
